<formly-form
    [form]="mechForm"
    [fields]="fields"
    [model]="model"
    (modelChange)="onModelChanged($event)"
></formly-form>
